import {Dispatch, FC, SetStateAction, useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {KTSVG} from '../../../../../../../../../../_metronic/helpers'
import {InputNumber, InputText} from '../../../../../../../../components/UI/Input'
import {useLavanderia} from '../../../../../../../../hooks/useLavanderia'
import {Select} from '../../../../../../../../components/UI/Select'
import {FormProvider, useForm} from 'react-hook-form'
import {EquipmentSupplierModel, SelectModel} from '../../../../../../model'
import {yupResolver} from '@hookform/resolvers/yup'
import * as Yup from 'yup'
import {getMasterService} from '../../../../../../../central/services'
import {createEquipSupplier, updateEquipSupplier} from '../../../../../../services'
import {ShowSnackBar} from '../../../../../../../../util/functions'
interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  getLegalRepresentatives: () => void
  created: boolean
  equipmentToEdit: EquipmentSupplierModel
}

const ModalEquipmentSupplier: FC<Props> = ({
  show,
  setShow,
  created,
  equipmentToEdit,
  getLegalRepresentatives,
}) => {
  const {currentTabItem} = useLavanderia()
  const [equipmentType, setEquipmentType] = useState<SelectModel[]>([])
  const [equipmentStatus, setEquipmentStatus] = useState<SelectModel[]>([])

  const handleClose = () => {
    setShow(false)
    resetForm()
  }

  const equipmentSupplierSchema = Yup.object().shape({
    tipoEquipo: Yup.string().required('Tipo de equipo es obligatorio'),
    nomenclatura: Yup.string().required('Nomenclatura es obligatorio'),
    capacidadLavadoUsuario: Yup.string().required(
      'Capacidad de Lavado Ropa Usuario es obligatorio',
    ),
    capacidadLavadoCama: Yup.string().required('Capacidad de Lavado Ropa Cama es obligatorio'),
    tiempo: Yup.string().required('Tiempo de entrega es obligatorio'),
    estado: Yup.string().required('Estado es obligatorio'),
  })

  const methods = useForm<EquipmentSupplierModel>({
    resolver: yupResolver(equipmentSupplierSchema),
  })

  const {
    register,
    setValue,
    handleSubmit,
    control,
    formState: {errors},
  } = methods

  const getEquipmentTypeList = async () => {
    try {
      const response = await getMasterService({
        pageNumber: 1,
        size: 100,
        tableName: 'TipoEquipo',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.codigo,
        label: master.nombreCorto,
        codigo: master.codigo,
      }))
      setEquipmentType(mappedMaster)
    } catch (error) {
      console.error('Error al obtener la lista de tipos de equipo:', error)
    }
  }

  const getEquipmentStatusList = async () => {
    try {
      const response = await getMasterService({
        pageNumber: 1,
        size: 100,
        tableName: 'EstadoEquipo',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.codigo,
        label: master.nombreCorto,
      }))
      setEquipmentStatus(mappedMaster)
    } catch (error) {
      console.error('Error al obtener la lista de estados de equipo:', error)
    }
  }

  useEffect(() => {
    getEquipmentTypeList()
    getEquipmentStatusList()
    setValue('proveedorId', currentTabItem.idToEdit as any)
    setValue('estado', 'ACT')
  }, [])

  const onSubmit = async (data: EquipmentSupplierModel) => {
    try {
      const {data: res} = created
        ? await createEquipSupplier(data)
        : await updateEquipSupplier(data)
      if (!res.error) {
        ShowSnackBar(`Se ${created ? 'creó' : 'actualizó'} con exito`)
        handleClose()
        getLegalRepresentatives()
        // mostrar snackbar
      } else {
        ShowSnackBar(res.message || 'Hubo un error', 'error')
      }
    } catch (error) {
      ShowSnackBar('Hubo un error', 'error')
    }
  }

  const resetForm = () => {
    setValue('tipoEquipo', '')
    setValue('nomenclatura', '')
    setValue('capacidadLavadoUsuario', '')
    setValue('capacidadLavadoCama', '')
    setValue('tiempo', '')
    setValue('observaciones', '')
    setValue('estado', '')
  }

  useEffect(() => {
    if (!created) {
      setValue('id', equipmentToEdit?.id)
      setValue('tipoEquipo', equipmentToEdit?.tipoEquipo)
      setValue('nomenclatura', equipmentToEdit?.nomenclatura)
      setValue('capacidadLavadoUsuario', equipmentToEdit?.capacidadLavadoUsuario)
      setValue('capacidadLavadoCama', equipmentToEdit?.capacidadLavadoCama)
      setValue('tiempo', equipmentToEdit?.tiempo)
      setValue('observaciones', equipmentToEdit?.observaciones)
      setValue('estado', equipmentToEdit?.estado ? equipmentToEdit?.estado?.slice(0, 3) : '')
    }
  }, [created])

  return (
    <Modal
      className='modal fade'
      show={show}
      dialogClassName='modal-lg'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h5 className='modal-title'>{created ? 'Crear' : 'Editar'} Equipo Proveedores</h5>

          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <FormProvider {...methods}>
            <form>
              <div className='row'>
                <div className='d-flex align-items-center'></div>
                <div className='row mt-2'>
                  <div className='col-sm-12 col-lg-6'>
                    <label className='required'>Tipo de Equipo:</label>
                    <Select
                      control={control}
                      name={`tipoEquipo`}
                      data={equipmentType}
                      errors={errors}
                    />
                  </div>
                  <div className='col-sm-12 col-lg-6'>
                    <label className='required'>Nomenclatura de Equipo:</label>
                    <InputText
                      name={`nomenclatura`}
                      textPlaceholder='Escribe la nomenclatura'
                      register={register}
                      errors={errors}
                    />
                  </div>
                  <div className='col-sm-12 col-lg-6'>
                    <label className='required'>Capacidad de lavado ropa usuario:</label>
                    <InputNumber
                      name={`capacidadLavadoUsuario`}
                      textPlaceholder='Escribe la capacidad de lavado ropa usuario'
                      register={register}
                      errors={errors}
                    />
                  </div>
                  <div className='col-sm-12 col-lg-6'>
                    <label className='required'>Capacidad de lavado ropa cama:</label>
                    <InputNumber
                      name={`capacidadLavadoCama`}
                      textPlaceholder='Escribe la capacidad de lavado ropa cama'
                      register={register}
                      errors={errors}
                    />
                  </div>
                  <div className='col-sm-12 col-lg-6'>
                    <label className='required'>Tiempo de entrega:</label>
                    <InputText
                      name={`tiempo`}
                      textPlaceholder='Escribe el tiempo de entrega'
                      register={register}
                      errors={errors}
                    />
                  </div>
                  <div className='col-sm-12 col-lg-6'>
                    <label className=''>Observaciones:</label>
                    <InputText
                      name={`observaciones`}
                      textPlaceholder='Escribe las observaciones'
                      register={register}
                      errors={errors}
                    />
                  </div>

                  <div className='col-sm-12 col-lg-6'>
                    <label className=''>Estado:</label>
                    <Select
                      control={control}
                      name={`estado`}
                      data={equipmentStatus}
                      errors={errors}
                    />
                  </div>
                </div>
              </div>
              {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
              <div className='d-flex justify-content-center mb-3 mt-5'>
                <button type='button' className='btn btn-light-primary me-5' onClick={handleClose}>
                  Cancelar
                </button>
                <button type='submit' className='btn btn-primary' onClick={handleSubmit(onSubmit)}>
                  Guardar
                </button>
              </div>
            </form>
          </FormProvider>
        </div>
      </div>
    </Modal>
  )
}

export {ModalEquipmentSupplier}
